module.exports = __webpack_public_path__ + "static/jeux-aa0a2b82718cb7790896e3c213d85eb8.png";